<template>
  <el-container>
    <el-header style="height: 120px;">
      <div class="all-search">
        <div class="search-input" >
          <el-input v-model="account" placeholder="用户名 或者 sn" ></el-input>
        </div>
        <div class="search-button" >
          <el-button type="primary"  @click="search">搜索</el-button>
        </div>
        <div class="search-reset" >
          <el-button type="primary"  @click="searchreset">重置</el-button>
        </div>
      </div>
      <div class="addcss" >
        <el-button type="primary"   @click="batchdelete">批量删除</el-button>
      </div>
      <div class="addcss" >
        <el-button type="primary"   @click="addUserAccount">增加</el-button>
      </div>
    </el-header>
    <el-main style="line-height:50px;">
      <div class="tabledata">
        <el-table :data="productsns" ref="multipleTable" style="width: auto" highlight-selection-row @selection-change="handleSelect" row-key="id">
          <el-table-column
            type="selection"
            v-if="showflag">
          </el-table-column>
<!--          <el-table-column type="index" :index="1 + this.queryInfo.pageSize * (this.queryInfo.pageNum - 1)"  label="序号" >-->
<!--          </el-table-column>-->
          <el-table-column  width="100px"
            prop="parentIndex"
            label="序号"
            align="left">
          </el-table-column>
          <el-table-column prop="uaccount.companyname" label="公司名称" >
          </el-table-column>
          <el-table-column prop="uaccount.account" label="用户名" >
          </el-table-column>
          <el-table-column prop="sn1" label="天空端sn" >
          </el-table-column>
          <el-table-column prop="udid" label="产品唯一标识" >
          </el-table-column>
<!--          <el-table-column prop="sn2" label="飞机sn" >-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="sn3" label="水桶sn" >-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="productType" label="设备类型代码（1:无人机，2:遥控器，3:吊桶）" >-->
<!--          </el-table-column>-->
          <el-table-column prop="deadLineDate" label="有效时间" >
          </el-table-column>
          <el-table-column prop="productType" label="产品" >
          </el-table-column>
<!--          <el-table-column prop="devicePerm" label="设备权限" >-->
<!--          </el-table-column>-->
          <el-table-column  label="操作">
            <template slot-scope="scope">
              <el-link  @click="editproductsns(scope.row)" style="color: #3B82F6">编辑</el-link>
              <el-link @click="deleteproductsns(scope.row.id)">删除</el-link>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </el-main>
    <el-footer><el-pagination background layout="sizes,total,prev, pager, next" :page-size="this.queryInfo.pageSize" :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange"  @current-change="changePage" :total="total" :current-page="this.queryInfo.pageNum">
    </el-pagination></el-footer>
  </el-container>
</template>

<script>
// import router from '../../router/index'
import axios from '../../../utils/request'

export default {
  data () {
    return {
      account: '',
      productsns: [],
      product_type: '',
      dialogFormVisible: false,
      queryInfo: {
        pageSize: 10,
        pageNum: 1
      },
      selectRowsdata: [],
      total: 0,
      formData: {
      },
      showflag: false,
      multipleSelection: [],
      typecode: '设备类型代码（1:无人机，2:遥控器，3:水枪）',
      productcode: 0
    }
  },

  mounted () {
    this.methodToTrigger()
  },
  methods: {
    methodToTrigger: function () {
      let that = this
      axios.get(`/data/bindsn/query?account=${this.account}&productId=2&productId=3&productId=4&productId=5&productId=6&productId=7&productId=8&pageNum=${this.queryInfo.pageNum}&pageSize=${this.queryInfo.pageSize}`).then(res => {
        that.productsns = res.list
        that.total = res.total
        that.setParentIndex(that.productsns, that.queryInfo.pageNum)
      })
    },
    handleSizeChange: function (val) {
      this.queryInfo.pageSize = val
      this.methodToTrigger()
    },
    addUserAccount: function () {
      this.$router.push('/data/addbucketproductsn')
    },
    search: function () {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 10
      this.methodToTrigger()
    },
    searchreset: function () {
      this.account = ''
      this.methodToTrigger()
    },
    changePage: function (val) {
      var that = this
      this.queryInfo.pageNum = val
      axios
        .get(`/data/bindsn/query?account=${this.account}&productId=2&productId=3&productId=4&productId=5&productId=6&productId=7&productId=8&pageNum=${val}&pageSize=${this.queryInfo.pageSize}`)
        .then(function (res) {
          that.productsns = res.list
          that.setParentIndex(that.productsns, that.queryInfo.pageNum)
          // that.total = res.data.total
          // console.log('total' + this.total)
        })
    },

    deleteproductsns: function (val) {
      var that = this
      that.$confirm('删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/data/bindsn/delete?id=${val}`)
          .then(function (res) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.methodToTrigger()
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    editproductsns: function (val) {
      console.log('val', val)
      this.$router.push({
        path: '/data/addbucketproductsn',
        query: {
          requesttype: 'update',
          account: val.uaccount.account,
          userAccountId: val.uaccount.id,
          sn1: val.sn1,
          sn2: val.sn2,
          sn3: val.sn3,
          productType: val.productType,
          deadLineDate: val.deadLineDate,
          productId: val.productId,
          companyname: val.uaccount.companyname,
          devicePerm: val.devicePerm,
          udid: val.udid,
          id: val.id
        }
      })
    },
    handleSelect: function (val) {
      // this.selectedRows = selection // 更新选中数据
      // console.log('当前选中行：', row)
      // console.log('所有选中数据：', this.selectedRows)
      // this.selectRowsdata = this.selectedRows
      this.multipleSelection = val
      this.selectRowsdata = this.multipleSelection
      console.log(' this.selectRowsdata：', this.selectRowsdata)
    },
    batchdelete: function () {
      var that = this
      var ids = ''
      for (var i = 0; i < that.selectRowsdata.length; i++) {
        if (i !== that.selectRowsdata.length - 1) {
          ids = ids + that.selectRowsdata[i].id + ','
        } else {
          ids = ids + that.selectRowsdata[i].id
        }
      }
      if (that.showflag === false) {
        that.$refs.multipleTable.clearSelection()
        that.selectRowsdata = []
        that.ids = ''
      }
      if (ids !== '') {
        that.$confirm('删除这些记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.delete(`/data/bindsn/delids?ids=${ids}`)
            .then(function (res) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              // that.showflag = false
              that.$refs.multipleTable.clearSelection()
              that.methodToTrigger()
            })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
          that.$refs.multipleTable.clearSelection()
          that.selectRowsdata = []
          that.ids = ''
        })
      }
      this.showflag = !this.showflag
    },
    setParentIndex (list, pageNum) {
      list.forEach((item, index) => {
        item.parentIndex = index + 1 + this.queryInfo.pageSize * (pageNum - 1) + ''
        if (item.children && item.children.length > 0) {
          this._setParentIndex(item, item.parentIndex)
        }
      })
    },
    _setParentIndex (item, oldIndex) {
      if (item.children && item.children.length > 0) {
        item.children.forEach((subItem, i) => {
          subItem.parentIndex = oldIndex + '.' + (i + 1)
          // this._setParentIndex(subItem, subItem.parentIndex)
        })
      } else {
      }
    }
  }
}
</script>

<style scoped>

  .el-container {
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:258px;
    height: 100%;
  }
  .el-header{
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
    padding:0;
  }
  .el-footer {
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding:0;
  }

  .el-main {
    margin: 0px -43px;
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .addcss {
    float: right;
    margin-right: 10px;
  }
  .tabledata {
    height:70vh;
    margin-left: 20px;
  }

  .search-input{
    float:left;
    margin-left: 10px;
  }
  .search-button{
    float:left;
    margin-left: 10px;
  }
  .search-reset{
    float:left;
    margin-left: 10px;
  }
  .all-search{
    overflow: hidden;
    margin-left: -16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/bucket/bucketproductsnbind.vue